module.exports = __webpack_public_path__ + "static/media/480.cf975907.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-fly/light/480.png
// module id = 2076
// module chunks = 2